<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.0127 11.9872L11.9872 4.0127" stroke="#36963A" stroke-miterlimit="10"/>
<path d="M4.0127 4.0127L11.9872 11.9872" stroke="#36963A" stroke-miterlimit="10"/>
</svg>
